import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  fromVerifyUser,
  VerifyUserEffects,
  VerifyUserFacade,
} from './+state/verify-user';
import {
  fromUploadPicture,
  UploadPictureEffects,
} from './+state/upload-picture';
import {
  RegisterCreditCardEffects,
  fromRegisterCreditCard,
} from './+state/register-credit-card';
import * as fromEditInfo from './+state/edit-info/edit-info.reducer';
import { EditInfoEffects } from './+state/edit-info/edit-info.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromVerifyUser.VERIFY_USER_FEATURE_KEY,
      fromVerifyUser.verifyUserReducer,
    ),
    EffectsModule.forFeature([VerifyUserEffects]),
    StoreModule.forFeature(
      fromUploadPicture.UPLOAD_PICTURE_FEATURE_KEY,
      fromUploadPicture.uploadPictureUploadPictureReducer,
    ),
    EffectsModule.forFeature([UploadPictureEffects]),
    StoreModule.forFeature(
      fromRegisterCreditCard.REGISTER_CREDIT_CARD_FEATURE_KEY,
      fromRegisterCreditCard.registerCreditCardReducer,
    ),
    EffectsModule.forFeature([RegisterCreditCardEffects]),
    StoreModule.forFeature(
      fromEditInfo.EDIT_INFO_FEATURE_KEY,
      fromEditInfo.editInfoReducer,
    ),
    EffectsModule.forFeature([EditInfoEffects]),
  ],
  providers: [VerifyUserFacade],
})
export class UserVerificationDataAccessModule {}
